import React, { useState, useEffect } from "react";
import BackBtn from "../../btncomponent/BackBtn";
import ShowImage from "../ShowImage";
import { isAuthenticated } from "../../auth";
import Swal from "sweetalert2";
import { Redirect } from "react-router-dom";

const Mybooking = (props) => {
  const [room, setRoom] = useState([]);

  const { user, token } = isAuthenticated();

  useEffect(() => {
    // const bookid = props.match.params.bookid;

    const fetchdata = () => {
      fetch(`${process.env.REACT_APP_API_URL}/roombook/by/${user._id}`, {
        method: "GET",
      })
        .then((res) => {
          return res.json();
        })
        .catch((err) => {
          console.log(err);
        })
        .then((data) => {
          if (data.error) {
            console.log(data.error);
          } else {
            setRoom(data);
          }
        });
    };
    fetchdata();
  }, [props]);

  return (
    <div className="container">
      <h2 className="mt-5 text-center " style={{ color: "#FCCE01" }}>
        <span style={{ borderBottom: "3px solid #17a2b866" }}>My B</span>ooking
      </h2>
      {room
        .map((data) => {
          return (
            <div className="card mt-5">
              <div className="card-body">
                <img
                  width="120px"
                  src={`${process.env.REACT_APP_API_URL}/home/photo/${data.roomimgid}`}
                  style={{ maxHeight: "100%", maxWidth: "100%" }}
                  className="mb-3"
                />
                <h6>
                  <span style={{ borderBottom: "3px solid #FCCE01" }}>
                    OrderId: {data.orderId}
                  </span>
                </h6>
                <h6>Room Name: {data.roomname}</h6>
                <h6>Room Desc.: {data.roomdesc}</h6>
                <h6>Booking Name: {data.name}</h6>
                <h6>Booking Email: {data.email}</h6>
              </div>
            </div>
          );
        })
        .reverse()}
    </div>
  );
};

export default Mybooking;
